import { BaseModel } from './BaseModel';

export class SectionRepeat extends BaseModel {
  static get entity() {
    return 'section-repeats';
  }

  static get fk() {
    return 'section_repeat_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      published_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      fetch(params = {}) {
        return this.get(`/section-repeats`, {
          params
        });
      }
    }
  };
}

export default SectionRepeat;
